<template>
  <div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="自定义" name="custom"></el-tab-pane>
      <el-tab-pane label="魔筷星选商家版APP" name="1"></el-tab-pane>
      <el-tab-pane label="企鹅小店商家版APP" name="2"></el-tab-pane>
      <el-tab-pane label="买家版APP" name="3"></el-tab-pane>
      <el-tab-pane label="星选小程序" name="4"></el-tab-pane>
      <el-tab-pane label="企鹅小店H5" name="5"></el-tab-pane>
    </el-tabs>
    <!-- 自定义 -->
    <custom v-if="activeName === 'custom'" @close="closeDialog" @select="select"></custom>
    <mockuai-seller-list v-else :source="activeName" @close="closeDialog" @select="select"></mockuai-seller-list>
  </div>
</template>

<script>
import Util from '@/js/util';

export default {
  props: {
    useType: {
      type: String,
      default: 'tms',
    }
  },
  data() {
    return {
      activeName: 'custom',
      idList: [],
    }
  },
  computed: {},
  created() {
  },
  methods: {
    /**
     * 链接助手选取回调
     * @param row 选取的数据对象
     */
    select(item) {
      let link = item.link,
          linkName = item.title,
          linkType = 0;
      this.$emit('select', link, linkName, linkType);
    },
    closeDialog() {
      this.$emit('close');
    }
  },
  components: {}
}
</script>

<style lang="sass">
</style>